import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import {atomButtonDesigns} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeNotification from '@s-ui/react-molecule-notification'
import {useRouter} from '@s-ui/react-router'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {BASE_CLASS, NOTIFICATION_PROPS, NOTIFICATION_TYPES} from './config.js'

export const Notification = ({type, comparatorSelectedAds = [], extendedTrackingData, onClose, className}) => {
  const {domain, i18n} = useContext(Context)
  const {push} = useRouter()
  const {track} = useAnalyticsTrack()

  const config = domain.get('config')
  const {COMPARATOR_PATH_PATTERN} = config.get('page')
  const {
    HIT_ORIGINS: {LIST_ADS_COMPARISON_BOTTOM_SHEET},
    TRACKING_EVENT_NAMES: {AD_TO_COMPARE_SEE_RESULTS_CLICKED}
  } = config.get('tracking')

  const hasAnySelectedAd = comparatorSelectedAds.length > 0
  const baseClassName = cx(BASE_CLASS, className)

  const trackClickingResults = async () => {
    const adComparatorTrackingData = await domain.get('get_event_tracking_data_use_case').execute({
      event: AD_TO_COMPARE_SEE_RESULTS_CLICKED,
      origin: LIST_ADS_COMPARISON_BOTTOM_SHEET,
      listType: extendedTrackingData?.products?.[0]?.list_type,
      ads: comparatorSelectedAds
    })
    track(adComparatorTrackingData)
  }

  const buttons = [
    {
      negative: true,
      design: atomButtonDesigns.LINK,
      children: i18n.t('COMPARATOR.ADS_LIST_MODAL_CTA_SHOW'),
      onClick: async () => {
        await trackClickingResults()
        push({
          pathname: COMPARATOR_PATH_PATTERN,
          query: {ids: comparatorSelectedAds.map(ad => ad.id).join(',')},
          state: {ads: comparatorSelectedAds, listType: extendedTrackingData?.products?.[0]?.list_type}
        })
      }
    }
  ]

  const buttonsProps = type === NOTIFICATION_TYPES.ADDED && hasAnySelectedAd ? {buttons} : {}

  const notificationLabels = {
    [NOTIFICATION_TYPES.ADDED]: i18n.t('COMPARATOR.ADDED_AD_NOTIFICATION', comparatorSelectedAds.length),
    [NOTIFICATION_TYPES.MAX_ADDED]: i18n.t('COMPARATOR.MAX_ADS_NOTIFICATION'),
    [NOTIFICATION_TYPES.REMOVED]: i18n.t('COMPARATOR.REMOVED_AD_NOTIFICATION'),
    [NOTIFICATION_TYPES.REMOVED_ALL]: i18n.t('COMPARATOR.REMOVED_ALL_ADS_NOTIFICATION')
  }

  return (
    <div className={baseClassName}>
      <MoleculeNotification onClose={onClose} {...buttonsProps} {...NOTIFICATION_PROPS[type]}>
        {notificationLabels[type]}
      </MoleculeNotification>
    </div>
  )
}

Notification.propTypes = {
  type: PropTypes.oneOf(Object.values(NOTIFICATION_TYPES)),
  onClose: PropTypes.func,
  comparatorSelectedAds: PropTypes.array,
  extendedTrackingData: PropTypes.object,
  className: PropTypes.string
}
